import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";

const DeleteModal = ({
  visible,
  title = "Delete Recording",
  message = "Are you sure you want to delete this recording? This action cannot be undone.",
  confirmLabel = "Delete",
  cancelLabel = "Cancel",
  onConfirm,
  onCancel,
  disabled = false,
}) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (visible) requestAnimationFrame(() => setShow(true));
    else setShow(false);
  }, [visible]);

  if (!visible) return null;

  // Inline styles as fallback for build issues
  const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
    opacity: show ? 1 : 0,
    transition: 'opacity 0.25s ease',
    pointerEvents: show ? 'all' : 'none',
  };

  const modalStyle = {
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    padding: '24px 28px',
    boxShadow: '0 10px 25px rgba(0, 0, 0, 0.2)',
    width: '400px',
    maxWidth: 'calc(100% - 32px)',
    transform: show ? 'translateY(0)' : 'translateY(20px)',
    opacity: show ? 1 : 0,
    transition: 'transform 0.25s ease, opacity 0.25s ease',
  };

  const titleStyle = {
    fontSize: '18px',
    fontWeight: '600',
    color: '#1e293b',
    marginBottom: '12px',
    margin: '0 0 12px 0',
  };

  const messageStyle = {
    fontSize: '15px',
    color: '#64748b',
    lineHeight: '1.5',
    marginBottom: '20px',
    margin: '0 0 20px 0',
  };

  const actionsStyle = {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px',
  };

  const modalContent = (
    <div style={overlayStyle} className={`delete-modal-overlay ${show ? "is-visible" : ""}`}>
      <div style={modalStyle} className={`delete-modal ${show ? "is-active" : ""}`}>
        <h3 style={titleStyle} className="delete-modal__title">{title}</h3>
        <p style={messageStyle} className="delete-modal__message">{message}</p>

        <div style={actionsStyle} className="delete-modal__actions">
          <button 
            className="btn btn-secondary" 
            onClick={onCancel}
            disabled={disabled}
            style={{ 
              padding: '8px 16px', 
              borderRadius: '6px', 
              border: '1px solid #d1d5db', 
              backgroundColor: '#f9fafb', 
              color: '#374151',
              cursor: disabled ? 'not-allowed' : 'pointer',
              opacity: disabled ? 0.6 : 1
            }}
          >
            {cancelLabel}
          </button>
          <button 
            className="btn btn-danger" 
            onClick={onConfirm}
            disabled={disabled}
            style={{ 
              padding: '8px 16px', 
              borderRadius: '6px', 
              border: '1px solid #dc2626', 
              backgroundColor: '#dc2626', 
              color: '#ffffff',
              cursor: disabled ? 'not-allowed' : 'pointer',
              opacity: disabled ? 0.6 : 1
            }}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );

  // ✅ Mount to <body> directly
  return createPortal(modalContent, document.body);
};

export default DeleteModal;
